import { render, staticRenderFns } from "./WelcomeHero.vue?vue&type=template&id=427d1a71"
import script from "./WelcomeHero.vue?vue&type=script&lang=js"
export * from "./WelcomeHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports